<template>
  <section class="container mb-80 sm:mb-90">
    <div class="card-wrapper md:flex md:-mx-10 lg:-mx-25 md:flex-initial">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="card-container"
      >
        <AppCard>
          <div
            @click="handleClick(card.title)"
            class="link-container"
            :class="cardStyles"
          >
            <AppSlant
              class="app-slant"
              slant="bottom-right"
              slant-sm="right-bottom"
              slant-md="bottom-right"
            >
              <div
                class="card__img-wrapper"
                :class="[cardImgWrapperStyles, card.bgClass]"
              >
                <h2 class="card__title">
                  {{ card.title }}
                  <p class="card__bg-text text-white">
                    <span class="card__bg-step inline-block">STEP</span>
                    <span class="card__bg-number">{{ index + 1 }}</span>
                  </p>
                </h2>
              </div>
            </AppSlant>

            <div class="card-text-container">
              <div
                v-if="card.title === 'Get Pre-Approved'"
                key="budget"
              >
                The first step is to learn what your true budget is.
                This is done by completing our online pre-approval application
                <span class="cta-link">here.</span>
              </div>
              <div
                v-else-if="card.title === 'Shop With Confidence'"
                key="financing"
              >
                We'll connect you with a local partner dealership who will
                show you cars that you already qualify for, saving you time
                and avoiding any stress.
              </div>
              <div
                v-else-if="card.title === 'Choose Your New Vehcile'"
                key="vehicle"
              >
                Choose a vehicle that is right for you and it's yours!
                Typically we can have you in a new car in as little as 48 hours.
              </div>
            </div>
          </div>
        </AppCard>
      </div>
    </div>
  </section>
</template>

<script>
import AppCard from '@/components/common/cards/AppCard2'
import AppSlant from '@/components/common/AppSlant'

export default {
  // Name
  name: 'InventoryCards',

  // Components
  components: {
    AppCard,
    AppSlant
  },

  // Data
  data () {
    return {
      cardStyles: [
        'card'
      ],

      cardImgWrapperStyles: [
        'rounded-t-15 sm:rounded-t-0 sm:rounded-l-15 md:rounded-t-15 md:rounded-l-0',
        'h-140 sm:h-310 md:h-140',
        'sm:w-310 md:w-full',
        // 'mb-20',
        'flex',
        'items-center',
        'flex-shrink-0'
      ],

      cardImgStyles: [
        'h-auto',
        'm-auto'
      ]
    }
  },

  // Computed
  computed: {
    cards () {
      return [
        {
          title: 'Get Pre-Approved',
          link: `/application?start=1`,
          external: true,
          linkText: 'Get a Car Loan',
          subtitle: 'Completed Applications',
          bgClass: 'bg-blue',
          imgClass: 'w-70',
          content: 'We help our customers get the vehicle they need, at a price they can afford.'
        },
        {
          title: 'Shop With Confidence',
          subtitle: 'Employees & Growing',
          bgClass: 'bg-blue',
          imgClass: 'w-100',
          content: 'We have been recognized as one of the fastest growing companies in North America.'
        },
        {
          title: 'Choose Your New Vehcile',
          subtitle: 'Happy Dealer Partners',
          link: `https://dealers.usadrives.com?`,
          external: true,
          newTab: true,
          linkText: 'Join Dealer Network',
          bgClass: 'bg-blue',
          imgClass: 'w-90',
          content: 'If you are a Car Dealership looking to reach more customers we invite you to join our Dealer Network.'
        }
      ]
    }
  },

  methods: {
    handleClick (cardTitle) {
      let dlEvent = ''
      if (cardTitle === 'Get Pre-Approved') {
        dlEvent = 'budget_discovery_continue'
      } else if (cardTitle === 'Shop With Confidence') {
        dlEvent = 'financing_approval_continue'
      } else if (cardTitle === 'Choose Your New Vehcile') {
        dlEvent = 'vehicle_selection_continue'
      }
      this.$emit('inventory-card-click', dlEvent)
    }
  }
}
</script>

<style scoped lang="scss">

  .get-started {
    margin-top: 15px;
    color: $theme-text-blue;
    font-weight: 600;
    &:focus:not(.focus-visible) {
      outline: none;
    }
    &:focus-visible {
      border: 2px solid blue;
    }
  }

  .link-container {
    cursor: pointer;
    &:hover {
      transform: translateY(-1px);
      transition: all .15s ease;
      .cta-link, .get-started {
        color: $theme-text-blue;
      }
    }
  }
  .cta-link {
    cursor: pointer;
    color: $theme-text-blue;
    text-decoration: underline;
    font-weight: 600;
  }

  .card-text-container {
    line-height: 1.5;
    color: #4a4a4a;
    font-family: Open Sans,sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
    margin-top: 20px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 30px;
    @include breakpoint('tablet-portrait-up') {
      flex-direction: row;
      margin-top: 0;
      padding-bottom: 0;
      width: 100%;
    }
    @include breakpoint('tablet-landscape-up') {
      align-items: flex-start;
      margin-top: 20px;
      padding-bottom: 30px;
    }
    @include breakpoint('desktop-up') {
      position: relative;
    }
  }

  .card-wrapper {
    line-height: 1.5;
    color: #4a4a4a;
    font-family: Open Sans,sans-serif;
    box-sizing: border-box;
    border: 0 solid #dedede;

    @include breakpoint('tablet-landscape-up') {
      display: flex;
      flex: 0 1 auto;
      margin-left: -10px;
      margin-right: -10px;
    }
    @include breakpoint('desktop-up') {
      margin-left: -25px;
      margin-right: -25px;
    }
  }

  .card-container {
    @include breakpoint('tablet-landscape-up') {
      line-height: 1.5;
      color: #4a4a4a;
      font-family: Open Sans,sans-serif;
      box-sizing: border-box;
      border: 0 solid #dedede;
      padding-left: 10px;
      padding-right: 10px;
      width: 33.33%;
    }

    @include breakpoint('desktop-up') {
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  .card__img-wrapper {
    line-height: 1.5;
    color: #4a4a4a;
    font-family: Open Sans,sans-serif;
    box-sizing: border-box;
    border: 0 solid #dedede;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    height: 140px;
    padding-left: 20px;
    padding-right: 20px;

    @include breakpoint('mobile-only') {
      position: relative;
    }

    @include breakpoint('tablet-portrait-up') {
      border-top-right-radius: 0;
      border-bottom-left-radius: 15px;
      justify-content: flex-start;
      height: 310px;
      width: 310px;
    }

    @include breakpoint('tablet-landscape-up') {
      border-bottom-left-radius: 0;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      height: 140px;
      width: 100%;
    }
  }

  .app-slant {
    line-height: 1.5;
    color: #4a4a4a;
    font-family: Open Sans,sans-serif;
    box-sizing: border-box;
    border: 0 solid #dedede;
    display: inline-block;
    position: relative;
    vertical-align: top;

    @include breakpoint('tablet-landscape-up') {
      width: 100%;
    }
  }

  .card {
    line-height: 1.5;
    color: #4a4a4a;
    font-family: Open Sans,sans-serif;
    box-sizing: border-box;
    border: 0 solid #dedede;
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 30px;
    box-shadow: 0 3px 20px 0 rgba(0,0,0,.16);

    @include breakpoint('tablet-portrait-up') {
      flex-direction: row;
      margin: auto;
      margin-bottom: 50px;
    }

    @include breakpoint('tablet-landscape-up') {
      height: 320px;
      flex-direction: column;
    }

    @include breakpoint('desktop-up') {
      margin-bottom: 0;
    }

      &__bg-text {
        text-align: right;
        box-sizing: border-box;
        border: 0 solid #dedede;
        margin: 0;
        font-size: 16px;
        line-height: 25px;
        color: #fff;
        font-weight: 700;
        opacity: .23;
        position: absolute;
        z-index: 1;

        @include breakpoint('mobile-only') {
          top: 4px;
          left: 14px;
        }

        @media (min-width: 375px) {
          left: 37px;
        }
        @include breakpoint('tablet-portrait-up') {
          text-align: left;
          font-size: 17px;
          line-height: 26px;
          top: 83px;
          left: 41px;
        }

        @include breakpoint('tablet-landscape-up') {
          top: 6px;
          left: 22px;
        }
    }

    &__title {
      box-sizing: border-box;
      margin: 0;
      font-weight: 600;
      margin-bottom: 20px;
      position: relative;
      text-align: right;
      color: #fff;
      z-index: 5;
      font-size: 24px;
      line-height: 32px;
      @include breakpoint('mobile-only') {
        position: static;
      }
      @media (min-width: 375px) {
        margin-right: 31px;
      }
      @include breakpoint('tablet-portrait-up') {
        max-width: 110px;
        position: static;
        text-align: left;
        width: 50px;
        margin-left: 90px;
        margin-right: 0;
      }
      @include breakpoint('tablet-landscape-up') {
        max-width: 100%;
        width: auto;
        margin-left: 64px;
        font-size: 22px;
      }
      @include breakpoint('desktop-up') {
        font-size: 24px;
      }
    }

    &__bg-step {
      text-align: right;
      line-height: 25px;
      display: inline-block;
      transform: rotate(-90deg);
      font-size: 24px;
      position: relative;
      top: 23px;
      right: 12px;
      @include breakpoint('tablet-portrait-up') {
        text-align: left;
        line-height: 26px;
      }
    }

    &__bg-number {
      text-align: right;
      line-height: 25px;
      position: relative;
      font-size: 100px;
      top: 40px;
      left: -28px;
      @include breakpoint('tablet-portrait-up') {
        text-align: left;
        line-height: 26px;
      }
      @include breakpoint('tablet-landscape-up') {
        top: 40px;
        left: -28px;
      }
    }
  }

.bg-blue {
  background-color: #1D9BF0;
}
</style>
